import { render } from "./wallet-transaction-table.vue?vue&type=template&id=590c9ed2&scoped=true"
import script from "./wallet-transaction-table.vue?vue&type=script&lang=js"
export * from "./wallet-transaction-table.vue?vue&type=script&lang=js"

import "./wallet-transaction-table.vue?vue&type=style&index=0&id=590c9ed2&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590c9ed2"]])

export default __exports__